import apiTO from '@/api/to';
import apiOption from '@/api/option';

const defaultState = () => ({
	listTO: [],
	TOStatus:[],
	listWarehouse: [],
	TOforApprove: [],
	listProduct: [],
	detailTO: {},
	toPagination: '',
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
	listProductNotSelected (state) {
		return state.listProduct.filter( (el) => {
			return el.selected == false
		})
	},
	listProductSelected (state) {
		return state.listProduct.filter( (el) => {
			return el.selected == true
		})
	},
	productTO(state) {
		if (Object.keys(state.detailTO).length > 0) {
			return state.detailTO.to_detail.map((el) => {
				return el
			})
		} else {
			return []
		}
	}
};

const mutations = {
	setTO(state, data) {
		state.listTO = data.data
		state.toPagination = data.pagination;
	},
	setWarehouse(state, data) {
		state.listWarehouse = data
	},
	setProduct(state, data) {
		state.listProduct = data.map( (el) => {
			el.selected = false
			el.quantity = 1
			return el
		});
	},
	setTOforApprove(state, data) {
		state.TOforApprove = data
	},
	setTOStatus(state, data) {
		state.TOStatus = data
	},
	setDetailTO(state, data) {
		state.detailTO = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataTO(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getTOAll({ commit }, params) {
		return new Promise((resolve) => {
			apiTO.getTOAll(params).then(({ data: { data } }) => {
				commit('setTO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setTO', { data: [], pagination: {} });
			});
		});
	},
	getTOIn({ commit }, params) {
		return new Promise((resolve) => {
			apiTO.getTOIn(params).then(({ data: { data } }) => {
				commit('setTO', { data: data.results, pagination: data.pagination });
				resolve()
			}).catch(() => {
				commit('setTO', { data: [], pagination: {} });
			});
		});
	},
	getTOOut({ commit }, params) {
		apiTO.getTOOut(params).then(({ data: { data } }) => {
			commit('setTO', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setTO', { data: [], pagination: {} });
		});
	},
	getTOStatus({ commit }, params) {
		return new Promise((resolve) => {
			apiTO.getTOStatus(params).then(({ data: { data } }) => {
				commit('setTOStatus', data.results);
				resolve()
			}).catch(() => {
				commit('setTOStatus', []);
			});
		});
	},
	getOptionTOforApprove({ commit }, params) {
		apiOption.getOptionTOforApprove(params).then(({ data: { data } }) => {
			commit('setTOforApprove', data.results);
		}).catch(() => {
			commit('setTOforApprove', []);
		});
	},
	getOptionWarehouse({ commit }) {
		apiOption.getOptionWarehouse().then(({ data: { data } }) => {
			commit('setWarehouse', data.results);
		}).catch(() => {
			commit('setWarehouse', []);
		});
	},
	getOptionWarehouseAll({ commit }) {
		apiOption.getOptionWarehouseAll().then(({ data: { data } }) => {
			commit('setWarehouse', data.results);
		}).catch(() => {
			commit('setWarehouse', []);
		});
	},
	getOptionProduct({ commit }) {
		apiOption.getOptionProduct().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	getOptionProductToReturn({ commit }) {
		apiOption.getOptionProductToReturn().then(({ data: { data } }) => {
			commit('setProduct', data.results);
		}).catch(() => {
			commit('setProduct', []);
		});
	},
	getDetailTO({ commit, dispatch }, params) {
		apiTO.detailTO(params).then(({ data: { data } }) => {
			commit('setDetailTO', data.results );
		}).catch((err) => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setDetailTO', {});
		});
	},
	async exportTOAll({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTO.exportTOAll(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data transfer stok'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportTO({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTO.exportTO(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data transfer stok'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportTOIN({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTO.exportTOIN(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data transfer stok'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportTOOUT({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTO.exportTOOUT(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data transfer stok'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async createTO({ commit, dispatch }, params) {
		await apiTO.createTO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Transfer Stok'
			}, { root: true });
		});
	},
	async createTORetur({ commit, dispatch }, params) {
		await apiTO.createTORetur(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat Transfer Stok Retur'
			}, { root: true });
		});
	},
	async approveTO({ commit, dispatch }, params) {
		await apiTO.approveTO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menyetujui Transfer Order'
			}, { root: true });
		});
	},
	async rejectTO({ commit, dispatch }, params) {
		await apiTO.rejectTO(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membatalkan Transfer Order'
			}, { root: true });
		});
	},
	async deleteTO({ commit, dispatch }, params) {
		await apiTO.deleteTO(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async approvalAdminTO({ commit, dispatch }, params) {
		await apiTO.approvalAdminTO(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
